import React, { useState } from "react";
import { Field, FormikProvider, useFormik } from "formik";
import { useHistory } from "react-router-dom";
// import { connect } from "react-redux";
import * as Yup from "yup";
import { Link } from "react-router-dom";
// import { injectIntl } from "react-intl";
// import * as auth from "../_redux/authRedux";
// import { register } from "../_redux/authCrud";
import axios from "axios"
import {NODE_API_URL} from "../../../../env_config";
import PhoneInput from "react-phone-input-2";
import "../../../../../node_modules/react-phone-input-2/lib/style.css";
import Select from 'react-select'

const initialValues = {
    firstname: "",
    lastname: "",
    email: "",
    supplier_name: "",
    password: "",
    retypepassword: "",
    moblie_no: "",
    country: "India",
    acceptTerms: false,
};

const customStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 9999 // You can set this to a value that ensures the menu appears on top of other elements
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999
    })
};

// Custom FormikSelect component
const FormikSelect = ({ field, form, options, ...props }) => {
    return (
        <Select
            {...props}
            options={options}
            name={field.name}
            value={options ? options.find(option => option.value === field.value) : ''}
            onChange={(option) => form.setFieldValue(field.name, option.value)}
            onBlur={field.onBlur}
        />
    );
};


function Regfrom() {

    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState("India");
    const [success , setSuccess] = useState(false)
    const RegistrationSchema = Yup.object().shape({
        firstname: Yup.string().required("First Name is required").min(2, " At least two characters required."),
        lastname: Yup.string().required("Last Name is required").min(2, " At least two characters required."),
        email: Yup.string()
            .email("Please Enter Valid Email Address")
            .required("Please Enter Valid Email Address"),
        supplier_name: Yup.string().required("Company Name is Required"),
        moblie_no: Yup.string().required("Mobile Number is Required").min(10, "Please enter a valid phone number"),
        password: Yup.string("Enter your new password")
            .min(8, " At least 8 characters required.")
            .required("Password is Required")
            .matches(
                "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})",
                " Please enter a Alphanumeric with both upper and lower case and symbol - @ . # $ & _ * Password."
            ),
        retypepassword: Yup.string("retype your new password")
            .oneOf([Yup.ref("password"), null], "Password must match")
            .min(8, " At least 8 characters required.")
            .required("Confirm Password is Required")
            .matches(
                "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})",
                " Please enter a Alphanumeric with both upper and lower case and symbol - @ . # $ & _ * Password."
            ),
        acceptTerms: Yup.bool().oneOf([true],"You need to accept the terms and conditions"),
    });

    const enableLoading = () => {
        setLoading(true);
    };

    const disableLoading = () => {
        setLoading(false);
    };

    const getInputClasses = (fieldname) => {
        if (formik.touched[fieldname] && formik.errors[fieldname]) {
            return "is-invalid";
        }

        if (formik.touched[fieldname] && !formik.errors[fieldname]) {
            return "is-valid";
        }

        return "";
    };

    const formik = useFormik({
        initialValues,
        validationSchema: RegistrationSchema,
        onSubmit: (values, { setStatus, setSubmitting }) => {
          const finalData = {
            "firstname":values.firstname,
            "lastname":values.lastname,
            "supplier_name":values.supplier_name,
            "country":values.country,
            "email":values.email,
            "password":values.password,
            "moblie_no":values.moblie_no
        }
        setTimeout(() => {
          axios({
            method: 'POST',
            url: `${NODE_API_URL}/SUPP/supp-registration`,
            headers: { 
                'Access-Control-Allow-Origin': '*', 
                'Content-Type': 'application/json'
              },
            data: finalData
          })
            .then(function (res) {
            //   console.log(res)
            //   console.log("finalData",finalData)
              disableLoading();
              setSubmitting(false);
              setSuccess(res.data.success)
            //   history.push({
            //     pathname: "/auth/login",
            //     state: {
            //         success:"Your account is Successfully Created. Please check your mailbox and verify your email address"
            //     },
            // });
              setTimeout(() => {
                //   window.location.replace('/auth/login')
                  setStatus("Your account is Successfully Created. Please check your mailbox and verify your email address");
              }, 350);
            })
            .catch((res) => {
            //   console.log(res.response)
              disableLoading();
              setSubmitting(false);
              setStatus(res.response.data.error);
            });
        }, 1000);

            setSubmitting(true);
            enableLoading();
            // console.log(values)
            // console.log(selected)
            
        },
    });

    let array = ['Afghanistan', "Aland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Barbuda", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Trty.", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Caicos Islands", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, Democratic Republic of the", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Futuna Islands", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard", "Herzegovina", "Holy See", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Jan Mayen Islands", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea", "Korea (Democratic)", "Kuwait", "Kyrgyzstan", "Lao", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "McDonald Islands", "Mexico", "Micronesia", "Miquelon", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "Nevis", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Principe", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Barthelemy", "Saint Helena", "Saint Kitts", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre", "Saint Vincent", "Samoa", "San Marino", "Sao Tome", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "South Carolina","Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia", "South Sandwich Islands", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "The Grenadines", "Timor-Leste", "Tobago", "Togo", "Tokelau", "Tonga", "Trinidad", "Tunisia", "Turkey", "Turkmenistan", "Turks Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "US Minor Outlying Islands", "Uzbekistan", "Vanuatu", "Vatican City State", "Venezuela", "Vietnam", "Virgin Islands (British)", "Virgin Islands (US)", "Wallis", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"];

    let countries = array.map(value => {
        return {
            value:value,
        label:value
        }
    })
    const CountryValue = countries.find(
        option => option.value === formik.values.country
    );

    return (
        <div className="login-form login-signin" style={{ display: "block" }}>
        {!success ?
           <>
                <div className="mb-5">
                    <h1>Create an account For Free </h1>
                    <p className="text-muted font-weight-bold">
                        {" "}
                        Please fill all details to create account{" "}
                    </p>
                </div>
                <FormikProvider value={formik}>
                    <form
                        id="kt_login_signin_form"
                        className="form fv-plugins-bootstrap fv-plugins-framework "
                        onSubmit={formik.handleSubmit}
                    >
                        {/* begin: Alert */}
                        {formik.status && (
                            <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                                <div className="alert-text font-weight-bold">
                                    {formik.status}
                                </div>
                            </div>
                        )}
                        {/* end: Alert */}
                        <div className="row">
                            {/* begin: firstname */}
                            <div className="form-group col-md-6 fv-plugins-icon-container">
                                <input
                                    placeholder="First Name"
                                    type="text"
                                    className={`form-control  ${getInputClasses(
                                        "firstname"
                                    )}`}
                                    name="firstname"
                                    {...formik.getFieldProps("firstname")}
                                />
                                {formik.touched.firstname && formik.errors.firstname ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            {formik.errors.firstname}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            {/* end:firstname */}
        
                            {/* begin: lastname */}
                            <div className="form-group col-md-6 pl-md-0 fv-plugins-icon-container">
                                <input
                                    placeholder="Last Name"
                                    type="lastname"
                                    className={`form-control  ${getInputClasses(
                                        "lastname"
                                    )}`}
                                    name="lastname"
                                    {...formik.getFieldProps("lastname")}
                                />
                                {formik.touched.lastname && formik.errors.lastname ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            {formik.errors.lastname}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            {/* end: lastname */}
                        </div>
        
                        {/* begin: email */}
                        <div className="form-group fv-plugins-icon-container">
                            <input
                                placeholder="Enter Email Address"
                                type="email"
                                className={`form-control  ${getInputClasses(
                                    "email"
                                )}`}
                                name="email"
                                {...formik.getFieldProps("email")}
                            />
                            {formik.touched.email && formik.errors.email ? (
                                <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                        {formik.errors.email}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {/* end: email */}
                        {/* begin: password */}
                        <div className="form-group fv-plugins-icon-container">
                            <input
                                placeholder="Enter Password"
                                type="password"
                                className={`form-control  ${getInputClasses(
                                    "password"
                                )}`}
                                name="password"
                                {...formik.getFieldProps("password")}
                            />
                            {formik.touched.password && formik.errors.password ? (
                                <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                        {formik.errors.password}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {/* end: password */}
        
                        {/* begin: Confirm password */}
                        <div className="form-group fv-plugins-icon-container">
                            <input
                                placeholder="Enter Confirm Password"
                                type="password"
                                className={`form-control  ${getInputClasses(
                                    "retypepassword"
                                )}`}
                                name="retypepassword"
                                {...formik.getFieldProps("retypepassword")}
                            />
                            {formik.touched.retypepassword &&
                            formik.errors.retypepassword ? (
                                <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                        {formik.errors.retypepassword}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {/* end: Confirm password */}
        
                        {/* begin: supplier_name */}
                        <div className="form-group fv-plugins-icon-container">
                            <input
                                placeholder="Enter Company Name"
                                type="text"
                                className={`form-control  ${getInputClasses(
                                    "supplier_name"
                                )}`}
                                name="supplier_name"
                                {...formik.getFieldProps("supplier_name")}
                            />
                            {formik.touched.supplier_name &&
                            formik.errors.supplier_name ? (
                                <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                        {formik.errors.supplier_name}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {/* end: supplier_name */}
        
                        <div className="row">
                            {/* begin: mobile_no */}
                            <div className="form-group col-md-12 fv-plugins-icon-container">
                                <PhoneInput
                                    placeholder="Contact Number"
                                    country={"in"}
                                    className={`form-control form-control-solid h-auto p-0 ${getInputClasses(
                                        "moblie_no"
                                    )}`}
                                    name="moblie_no"
                                    // {...formik.getFieldProps("moblie_no")}
                                    onChange={(value) => formik.setFieldValue("moblie_no",value)}
                                />
                                {formik.touched.moblie_no && formik.errors.moblie_no ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            {formik.errors.moblie_no}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            {/* end:mobile_no */}
        
                            {/* begin: country */}
                            <div className="form-group col-md-12 fv-plugins-icon-container">
                            
                                    <Field
                                        name="country"
                                        component={FormikSelect}
                                        options={countries}
                                        defaultValue={CountryValue}
                                        styles={customStyles}
                                        placeholder="Select Country"
                                        menuPortalTarget={document.body}
                                    />
                                    {formik.errors.country ? (
                                        <div className="text-danger">
                                            {formik.errors.country}
                                        </div>
                                    ) : null}
                                
        
                                {formik.touched.country && formik.errors.country ? (
                                    <div className="fv-plugins-message-container">
                                        <div className="fv-help-block">
                                            {formik.errors.country}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            {/* end: country */}
                        </div>
                        {/* begin: Terms and Conditions */}
                        <div className="form-group">
                            <label className="checkbox">
                                <input
                                    type="checkbox"
                                    name="acceptTerms"
                                    className="m-1"
                                    {...formik.getFieldProps("acceptTerms")}
                                />
                                <Link
                                    to="/terms"
                                    target="_blank"
                                    className="mr-1"
                                    rel="noopener noreferrer"
                                >
                                    I agree the Terms & Conditions
                                </Link>
                                <span />
                            </label>
                            {formik.touched.acceptTerms && formik.errors.acceptTerms ? (
                                <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">
                                        {formik.errors.acceptTerms}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {/* end: Terms and Conditions */}
                        <div className="form-group d-flex justify-content-end mb-2">
                            <button
                                type="submit"
                                // disabled={
                                //     formik.isSubmitting ||
                                //     !formik.isValid ||
                                //     !formik.values.acceptTerms
                                // }
                                className="btn btn-primary font-weight-bold px-9"
                            >
                                <span>Create Account</span>
                                {loading && (
                                    <span className="ml-3 spinner spinner-white"></span>
                                )}
                            </button>
                        </div>
                    </form>
                </FormikProvider>
           </>
        : 
            formik.status && (
                <div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
                    <div className="alert-text font-weight-bold">
                        {formik.status}
                    </div>
                </div>
            )
        }
            <div className="text-right">
                Already have account ? <Link to="/auth/login">Login Here</Link>
            </div>
        </div>
    );
}

export default Regfrom;
